import React from 'react';
import { Mail, Twitter, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer id="contact" className="relative bg-gradient-to-t from-blue-950 to-blue-900/50">
      <div className="absolute inset-0 bg-blue-950/50" />
      
      <div className="relative max-w-[90rem] mx-auto px-8 py-24">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Get in Touch</h2>
          <div className="h-1 w-24 bg-gradient-to-r from-blue-400 to-cyan-300 mx-auto" />
        </div>

        <div className="grid md:grid-cols-2 gap-16 items-center max-w-4xl mx-auto">
          {/* Contact Info */}
          <div className="space-y-8">
            <div className="bg-blue-900/30 backdrop-blur-sm rounded-lg p-8 border border-blue-800">
              <h3 className="text-2xl font-semibold text-white mb-6">Contact Information</h3>
              <div className="space-y-6">
                <a 
                  href="mailto:nicksolo96@hotmail.com"
                  className="flex items-center gap-4 text-blue-200 hover:text-white transition-colors group"
                >
                  <Mail className="w-6 h-6 text-blue-400 group-hover:text-blue-300" />
                  <span>nick@aiss.solutions</span>
                </a>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div className="space-y-8">
            <div className="bg-blue-900/30 backdrop-blur-sm rounded-lg p-8 border border-blue-800">
              <h3 className="text-2xl font-semibold text-white mb-6">Follow Me</h3>
              <div className="flex gap-6">
                <a 
                  href="https://www.linkedin.com/in/solonick96/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-4 bg-blue-800/50 rounded-lg border border-blue-700 hover:border-blue-400 transition-all group"
                >
                  <Linkedin className="w-6 h-6 text-blue-400 group-hover:text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>
 
        {/* Copyright */}
        <div className="text-center mt-24">
          <p className="text-blue-300 text-sm">
            © {new Date().getFullYear()} AISS. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 